module.exports = __webpack_public_path__ + "img/camera_icon.6b41b1df.svg";